import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Image } from 'src/app/models/image.model';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit, OnChanges, OnDestroy {

  @Input()
  imagesInput: Image[] = [];
  images: any[] = [];
  item: any;
  boucle: any;

  currentIndex = 0;

  responsiveOptions:any[] = [
    {
        breakpoint: '1024px',
        numVisible: 5
    },
    {
        breakpoint: '768px',
        numVisible: 3
    },
    {
        breakpoint: '560px',
        numVisible: 1
    }
  ];

  constructor(private i18n: TranslateService) { }

  ngOnInit(): void {
    this.transform();
    this.boucle = setInterval(() => {
      
      if(this.currentIndex == this.images.length - 1) {
        this.currentIndex = 0;
      } else {
        this.currentIndex++;
      }
      
      this.item = this.images[this.currentIndex];
    }, 5000);

  }

  ngOnChanges(changes: SimpleChanges) {
    this.imagesInput = changes.imagesInput.currentValue;
    this.transform();
  }

  ngOnDestroy() {
    if(this.boucle) {
      clearInterval(this.boucle);
    }
  }

  private transform() {
    this.images = [];
    this.imagesInput.forEach((image: Image) => {
      const title = this.i18n.instant(image.codeTrad);
      const img = {
        "previewImageSrc": image.path,
        "alt": title,
        "title": title
      };

      this.images.push(img);
    });

    // show first image
    if(this.images.length > 0) {
      this.currentIndex = 0;
      this.item = this.images[0];
    }
  }

}
